export const PrivacyPolicyContentALM = () => {
    return (
        <div>
            <h3 className="mt-2">Privacy Policy</h3>

            <p>ALM Trading (“we,” “our,” “us”) values your privacy. This Privacy Policy explains how we collect, use, and share information when you use our software, website, and related services (collectively, the “Platform”).</p>

            <p>If you are accessing our Platform through a licensor, please note that <strong>your licensor is the primary provider of your trading relationship</strong>. ALM Trading provides the software under license to your licensor but does not manage your trading accounts, funds, or financial relationship with your licensor.</p>

            <p>By using our Platform, you agree to the practices described in this Privacy Policy.</p>

            <div className="section">
                <h2>1. Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul>
                    <li><strong>Personal Information:</strong> Name, email address, contact details, and account credentials.</li>
                    <li><strong>Trading-Related Information:</strong> Account activity, algorithm usage, trading performance, and related analytics.</li>
                    <li><strong>Technical Information:</strong> IP addresses, device identifiers, browser type, operating system, and login history.</li>
                    <li><strong>Cookies & Tracking:</strong> We may use cookies and similar technologies to improve functionality, analyze usage, and provide security.</li>
                </ul>
            </div>

            <div className="section">
                <h2>2. How We Use Information</h2>
                <p>We use information for the following purposes:</p>
                <ul>
                    <li>To operate, maintain, and improve the Platform.</li>
                    <li>To authenticate users and secure access.</li>
                    <li>To provide customer support and respond to inquiries.</li>
                    <li>To comply with legal and regulatory obligations.</li>
                    <li>To analyze Platform performance and usage trends.</li>
                </ul>
            </div>

            <div className="section">
                <h2>3. Sharing of Information</h2>
                <p>We may share your information with:</p>
                <ul>
                    <li><strong>Your Licensor:</strong> When you access the Platform through a licensor, we may share data necessary to enable your use of the software and to support your trading activities.</li>
                    <li><strong>Service Providers:</strong> Third-party vendors that help us operate the Platform (e.g., hosting, analytics, security).</li>
                    <li><strong>Legal & Regulatory Authorities:</strong> When required by law, regulation, or valid legal request.</li>
                </ul>
                <p><strong>We do not sell personal data to third parties.</strong></p>
            </div>

            <div className="section">
                <h2>4. Data Retention</h2>
                <p>We retain personal data only as long as necessary for the purposes described in this Policy, including legal, accounting, or reporting requirements. If your account is closed, we may retain certain data for a period consistent with our legal obligations.</p>
            </div>

            <div className="section">
                <h2>5. Data Security</h2>
                <p>We use reasonable technical, organizational, and administrative measures to protect your information. However, no system or transmission over the Internet is completely secure, and we cannot guarantee absolute security.</p>
            </div>

            <div className="section">
                <h2>6. Your Rights</h2>
                <p>Depending on your location, you may have the following rights:</p>
                <ul>
                    <li>Access the personal information we hold about you.</li>
                    <li>Request correction or deletion of your personal information.</li>
                    <li>Object to or restrict our processing of your data.</li>
                    <li>Request a copy of your data in a portable format.</li>
                    <li>Withdraw consent where processing is based on consent.</li>
                </ul>
                <p>To exercise these rights, contact your licensor.</p>
            </div>

            <div className="section">
                <h2>7. International Transfers</h2>
                <p>If you access the Platform from outside the United States, your data may be transferred to and processed in the United States. By using the Platform, you consent to this transfer.</p>
            </div>

            <div className="section">
                <h2>8. Children’s Privacy</h2>
                <p>The Platform is not intended for individuals under the age of 18. We do not knowingly collect information from anyone under 18. If we learn we have collected such information, we will delete it.</p>
            </div>

            <div className="section">
                <h2>9. Changes to this Policy</h2>
                <p>We may update this Privacy Policy from time to time. When we make material changes, we will notify you by posting the updated policy and updating the “Last Updated” date above.</p>
            </div>

            <div className="section">
                <h2>10. Contact Us</h2>
                <p>If you have questions about this Privacy Policy, contact your licensor.</p>
            </div>

        </div>
    )
}

